import React from "react";

import { Route, Switch } from "react-router-dom";
import {
  CREATE_ACCOUNT,
  LANDING_SCREEN,
  LOGIN,
  PASSWORD_RECOVERY,
  RECOVERY_LINK_SENT,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
} from "routers/routePaths";

import { Login } from "screens/auth/Login";
import { Landing } from "screens/Landing";
import { CreateAccount } from "screens/auth/CreateAccount";
import { PasswordRecovery } from "screens/auth/PasswordRecovery";

import { NewPassword } from "screens/auth/NewPassword";
import { ResetSuccess } from "screens/auth/ResetSuccess";
import { LinkSent } from "screens/auth/LinkSent";
import { FrameConfirmation } from "screens/external/FrameConfirmation";
import { RetrospectiveRouter } from "./retrospective";

export const UnprotectedRouter = () => {
  return (
    <Switch>
      <Route exact path={LANDING_SCREEN} component={Landing} />
      <Route exact path={LOGIN} component={Login} />
      <Route exact path={CREATE_ACCOUNT} component={CreateAccount} />
      <Route
        exact
        path={`${PASSWORD_RECOVERY}/:email?`}
        component={PasswordRecovery}
      />
      <Route exact path={RECOVERY_LINK_SENT} component={LinkSent} />
      <Route
        exact
        path={`${RESET_PASSWORD}/:resetID/:verification`}
        component={NewPassword}
      />
      <Route exact path={RESET_PASSWORD_SUCCESS} component={ResetSuccess} />
      <Route
        exact
        path="/external/confirmation"
        component={FrameConfirmation}
      />
      <Route path="/retrospectiva" component={RetrospectiveRouter} />
    </Switch>
  );
};
